import { render, staticRenderFns } from "./DashboardCardListGroup.vue?vue&type=template&id=f05ab99e&scoped=true&"
import script from "./DashboardCardListGroup.vue?vue&type=script&lang=js&"
export * from "./DashboardCardListGroup.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCardListGroup.vue?vue&type=style&index=0&id=f05ab99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05ab99e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileContent } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VChip,VDivider,VExpansionPanel,VExpansionPanelContent,VFlex,VLayout,VList,VListTile,VListTileContent,VListTileTitle,VTooltip})
